<template>
  <a-form
    id="formLogin"
    class="user-layout-login"
    :form="form"
    @submit.prevent="handleSignIn"
  >
    <h3><span>{{$t('userLogin.userLogin')}}</span></h3>
    <a-alert v-if="errMsg" type="error" showIcon style="margin-bottom: 24px;" :message="errMsg" />

    <a-form-item>
      <a-input
        size="large"
        type="text"
        :placeholder="$t('userLogin.usernameTxt')"
        :maxLength="20"
        @change="() => { errMsg&&(errMsg='') }"
        v-decorator="[
          'loginName',
          {
            rules: [{ required: true, message: $t('userLogin.usernameBlank') }],
            validateTrigger: 'change'
          }
        ]"
      >
        <a-icon slot="prefix" type="user" :style="{ color: 'rgba(0,0,0,.25)' }"/>
      </a-input>
    </a-form-item>

    <a-form-item>
      <a-input-password
        size="large"
        type="password"
        autocomplete="false"
        :placeholder="$t('userLogin.passwordTxt')"
        :maxLength="16"
        @change="() => { errMsg&&(errMsg='') }"
        v-decorator="[
          'password',
          {
            rules: [
              { required: true, message: $t('userLogin.passwordBlank') },
              { min: 8, message: $t('userLogin.passwordMinLength') },
            ],
            validateTrigger: 'change'
          }
        ]"
      >
        <a-icon slot="prefix" type="lock" :style="{ color: 'rgba(0,0,0,.25)' }"/>
      </a-input-password>
    </a-form-item>

    <a-row :gutter="16">
      <a-col class="gutter-row" :span="18">
        <a-form-item>
          <a-input
            size="large"
            type="text"
            :placeholder="$t('userLogin.varifyCodeTxt')"
            :maxLength="4"
            @change="() => { errMsg&&(errMsg='') }"
            v-decorator="[
              'varifyCode',
              {
                rules: [{ required: true, message: $t('userLogin.varifyCodeBlank') }],
                validateTrigger: 'change'
              }
            ]">
            <a-icon slot="prefix" type="mail" :style="{ color: 'rgba(0,0,0,.25)' }"/>
          </a-input>
        </a-form-item>
      </a-col>
      <a-col class="gutter-row" :span="6">
        <img class="code-img" :src="codeImgUrl" alt="登录验证码" @click="getVerificationImage">
      </a-col>
    </a-row>

    <a-form-item style="margin-top:24px">
      <a-button
        size="large"
        type="primary"
        htmlType="submit"
        class="login-button"
        :loading="btnLogging"
        :disabled="btnLogging"
      >{{$t('userLogin.loginBtn')}}</a-button>
    </a-form-item>

    <a-form-item style="margin-bottom: 0">
      <router-link :to="{ name: 'userChangePassword' }">{{$t('userLogin.forgetPasswordBtn')}}</router-link>
      <router-link :to="{ name: 'userRegister' }" style="float: right;">{{$t('userLogin.registerBtn')}}</router-link>
    </a-form-item>
    <div class="lang-select">
      <span
        :class="lang === 'zh_CN' ? 'checked' : ''"
        @click="()=>{changeLang('zh_CN')}"
      > 中文 </span> /
      <span
        :class="lang === 'en_US' ? 'checked' : ''"
        @click="()=>{changeLang('en_US')}"
      > English </span>
    </div>
  </a-form>
</template>

<script>

import { timeFix } from '@/utils/utils'
import { mapMutations, mapState } from 'vuex';
import { userSignIn, validateVerifyCode } from '@/api/userMana';

export default {
  name: 'login',
  components: {},
  data() {
    return {
      form: this.$form.createForm(this),
      btnLogging: false, // 是否正在提交登录
      errMsg: '',

      codeImgUrl: '',
      varifyCode: ''
    }
  },
  computed: {
    ...mapState(['lang'])
  },
  created() {
    this.getVerificationImage()
  },
  methods: {
    ...mapMutations(['changeLang', 'refreshUserInfo']),

    getVerificationImage() {
      this.codeImgUrl = '/face/web/users/verification_codes?' + new Date().getTime()
    },

    handleSignIn() {
      this.form.validateFields(async (err, values) => {
        if (!err) {
          try {
            this.btnLogging = true;
            await validateVerifyCode({ code: values.varifyCode })
            const res = await userSignIn({
              loginName: values.loginName,
              password: values.password
            })
            this.btnLogging = false;

            const data = res.data.collection[0];
            this.refreshUserInfo(data)
            this.$router.push({ path: '/' });
            setTimeout(() => {
              this.$notification.success({
                message: timeFix(this.lang) + '，' + this.$t('userLogin.loginSuccess')
              })
            }, 1000)
          } catch (error) {
            this.btnLogging = false;
            this.getVerificationImage();
            if (error.response) this.errMsg = error.response.data.message
            // console.dir(error)
          }
        }
      });
    }
  }
}
</script>
<style lang="less" scoped>
.user-layout-login {
  padding: 60px;
  h3 {
    margin-bottom: 20px;
    font-size: 20px;
    color: white;
  }

  label {
    font-size: 14px;
  }

  button.login-button {
    padding: 0 15px;
    font-size: 16px;
    height: 40px;
    width: 100%;
  }

  .user-login-other {
    text-align: left;
    margin-top: 24px;
    line-height: 22px;

    .item-icon {
      font-size: 24px;
      color: rgba(0, 0, 0, 0.2);
      margin-left: 16px;
      vertical-align: middle;
      cursor: pointer;
      transition: color 0.3s;

      &:hover {
        color: #1890ff;
      }
    }
  }

  .code-img{
    float: right;
    width: 100%;
    height: 40px;
  }
}
.lang-select {
  margin-bottom: 0;
  text-align:right;
  color: rgba(255, 255, 255, 0.5);
}
.lang-select>span{
  cursor: pointer;
}
.lang-select>span.checked{
  color: #1890ff;
}
</style>
